import { Link } from '@tanstack/react-router';
import BlogPreview from './BlogPreview';
import { getPost } from '../blog';

// Cards linking to specific blog posts; slugs that don't exist are skipped.
export default function RelatedGuides({ slugs, title = 'Guides', className = '' }) {
  const posts = slugs.map(getPost).filter(Boolean);
  if (posts.length === 0) return null;

  return (
    <section className={className}>
      <div className="flex items-baseline justify-between gap-4 mb-6">
        <h2 className="text-2xl font-bold text-foreground">{title}</h2>
        <Link to="/blog" className="text-sm font-medium text-accent hover:text-accent/80">
          All articles
        </Link>
      </div>
      <div className={`grid gap-6 ${posts.length > 2 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
        {posts.map((post) => (
          <BlogPreview key={post.slug} post={post} compact />
        ))}
      </div>
    </section>
  );
}
